import React from 'react';
import { useInView } from '../../hooks/useInView';
import './WhyChooseUsSection.css';

const WhyChooseUsSection: React.FC = () => {
  const { ref: whyRef, isInView: whyInView } = useInView<HTMLElement>({ threshold: 0.22 });
  const features = [
    {
      marker: '01',
      title: '40+ Years Experience',
      description: 'Four decades of expertise in crafting premium trophies and awards'
    },
    {
      marker: '02',
      title: 'Irish Craftsmanship',
      description: 'Traditional techniques combined with modern innovation'
    },
    {
      marker: '03',
      title: 'Bespoke Solutions',
      description: 'Custom designs tailored to your specific needs and occasions'
    },
    {
      marker: '04',
      title: 'Quality Guaranteed',
      description: 'Premium materials ensuring your awards stand the test of time'
    }
  ];

  return (
    <section ref={whyRef} className={`why-choose-us-section ${whyInView ? 'why-visible' : ''}`}>
      <div className="why-choose-us-container">
        <div className="why-choose-us-topline" aria-hidden="true" />
        <div className="why-choose-us-header">
          <p className="why-choose-us-eyebrow">Crafted Confidence</p>
          <h2 className="why-choose-us-title">Why Choose Quirke Trophies?</h2>
          <p className="why-choose-us-description">
            With over 50 years of experience, we've been an integral part of community life in South Tipperary,
            helping celebrate achievements in sport, education, community activism, and the Arts.
          </p>
        </div>
        <div className="why-choose-us-features">
          {features.map((feature, index) => (
            <article
              key={index}
              className={`why-choose-us-feature ${index % 2 === 0 ? 'why-choose-us-feature-left' : 'why-choose-us-feature-right'}`}
              style={{ ['--why-index' as any]: index }}
            >
              <div className="why-feature-marker-wrap">
                <span className="why-feature-marker">{feature.marker}</span>
                <span className="why-feature-accent" aria-hidden="true" />
              </div>
              <div className="why-choose-us-feature-content">
                <h3 className="why-choose-us-feature-title">{feature.title}</h3>
                <p className="why-choose-us-feature-description">{feature.description}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUsSection;

